import { render, staticRenderFns } from "./Linkding.vue?vue&type=template&id=039e662c&scoped=true"
import script from "./Linkding.vue?vue&type=script&lang=js"
export * from "./Linkding.vue?vue&type=script&lang=js"
import style0 from "./Linkding.vue?vue&type=style&index=0&id=039e662c&prod&scoped=true&lang=scss"
import style1 from "./Linkding.vue?vue&type=style&index=1&id=039e662c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e662c",
  null
  
)

export default component.exports